import getValueOffPercent from 'lib/offer/getValueOffPercent'
import {
  BookmarkDatesAndOccupancy,
  SavedHotelData,
} from 'tripPlanner/types/tripItem'
import { convertBedbankPropertyAddressToRegion } from 'tripPlanner/utils'
import {
  CreateAccommodationRequestBody,
  getBedbankCheckInOutTime,
  getCheckInCheckOutOccupancy,
} from 'tripPlanner/utils/itemConversions/common'

interface Params {
  offer: App.BedbankOffer | App.BedbankOfferSummary
  datesAndGuests: BookmarkDatesAndOccupancy
  currentRegionCode: string
  currencyCode: string
  price?: number
  value?: number
  roomTypeId?: string
}

export function createBedbankItemPayload({
  offer,
  datesAndGuests,
  currentRegionCode,
  currencyCode,
  price,
  value,
  roomTypeId,
}: Params): CreateAccommodationRequestBody {
  let region = ''
  if (offer.property.address) {
    region = convertBedbankPropertyAddressToRegion(offer.property.address)
  }

  const discountPercent =
    typeof price === 'number' && typeof value === 'number' ?
      getValueOffPercent(value, price) :
      undefined

  // When we do not have any room option for selected dates/guests,
  // we won't get a price.
  // In such cases, we do not want to save dates/guests in the trip item
  const datesAndOccupancy =
    typeof price === 'number' ? getCheckInCheckOutOccupancy(datesAndGuests) : {}

  const savedHotelData: SavedHotelData = {
    offerType: offer.type,
    regionCode: currentRegionCode,
    currencyCode,
    offerId: offer.id,
    packageId: roomTypeId,
    roomTypeId,
    price,
    value,
    discountPercent,
    roomTypeName:
      roomTypeId && 'packages' in offer ?
        offer.packages.find((p) => p.roomId === roomTypeId)?.name :
        undefined,
    ...datesAndOccupancy,
  }

  const [checkInTime, checkOutTime] = getBedbankCheckInOutTime(
    offer.property.finePrint,
  )

  return {
    type: 'ACCOMMODATION',
    isBooked: false,
    status: 'PLANNED',
    sourceType: 'LE_Hotel_Bedbank',
    startDate: datesAndOccupancy.checkIn,
    endDate: datesAndOccupancy.checkOut,
    startTime: checkInTime,
    endTime: checkOutTime,
    place: {
      type: 'GEO',
      id: offer.property.id,
      address: offer.property.address.line1,
      name: offer.name,
      point: {
        lat: offer.property.latitude,
        lng: offer.property.longitude,
      },
      region,
    },
    code: offer.id,
    subCode: roomTypeId,
    savedItemData: savedHotelData,
  }
}
